var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReason(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 8C6.25 7.58579 6.58579 7.25 7 7.25H13C13.4142 7.25 13.75 7.58579 13.75 8C13.75 8.41421 13.4142 8.75 13 8.75H7C6.58579 8.75 6.25 8.41421 6.25 8ZM6.25 12C6.25 11.5858 6.58579 11.25 7 11.25H17C17.4142 11.25 17.75 11.5858 17.75 12C17.75 12.4142 17.4142 12.75 17 12.75H7C6.58579 12.75 6.25 12.4142 6.25 12Z",
    fill: "#1F2937"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.75C4.66848 3.75 4.35054 3.8817 4.11612 4.11612C3.8817 4.35054 3.75 4.66848 3.75 5V19.8621L5.81433 17.2815C6.07194 16.9597 6.39879 16.6998 6.77031 16.5213C7.14183 16.3428 7.54873 16.2501 7.96091 16.25H19C19.3315 16.25 19.6495 16.1183 19.8839 15.8839C20.1183 15.6495 20.25 15.3315 20.25 15V5C20.25 4.66848 20.1183 4.35054 19.8839 4.11612C19.6495 3.8817 19.3315 3.75 19 3.75H5ZM2.25 20.29V5C2.25 4.27065 2.53973 3.57118 3.05546 3.05546C3.57118 2.53973 4.27065 2.25 5 2.25H19C19.7293 2.25 20.4288 2.53973 20.9445 3.05546C21.4603 3.57118 21.75 4.27065 21.75 5V15C21.75 15.7293 21.4603 16.4288 20.9445 16.9445C20.4288 17.4603 19.7293 17.75 19 17.75H7.96109C7.96106 17.75 7.96112 17.75 7.96109 17.75C7.77377 17.75 7.58876 17.7922 7.41991 17.8733C7.25114 17.9544 7.10274 18.0724 6.98567 18.2185C6.9856 18.2186 6.98574 18.2184 6.98567 18.2185L4.65525 21.1318C4.65522 21.1318 4.65528 21.1317 4.65525 21.1318C4.48072 21.3505 4.24247 21.5096 3.97359 21.5871C3.70467 21.6645 3.41833 21.6565 3.15419 21.564C2.89004 21.4716 2.66114 21.2994 2.49915 21.0712C2.33717 20.843 2.2501 20.5698 2.25 20.29ZM3.48275 20.1962C3.48294 20.196 3.48313 20.1957 3.48333 20.1955L3.48275 20.1962Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason);
export default __webpack_public_path__ + "static/media/reason.45bc2daca752683570dc659a490be935.svg";
export { ForwardRef as ReactComponent };